import OpdekDeur from "entities/configurator/product-scene/doors/opdek";
import { Vector3 } from "three";
import { ObjectMap } from "@react-three/fiber";
import { ConfigurationProps } from "../../Door";

interface SingleOpdekKozijnProps extends ConfigurationProps {}

const SingleOpdekKozijn = ({
  materials,
  position,
  scale,
  doorSettings,
}: SingleOpdekKozijnProps) => {
  return (
    <group scale={scale}>
      <OpdekDeur
        materials={materials}
        position={position}
        kozijnColorSync={false}
        kozijnSettings={doorSettings?.main?.kozijnSettings}
      />
    </group>
  );
};
export default SingleOpdekKozijn;
